<template>
  <div style="background: #fefbfb; min-height: 100vh">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      loader="dots"
      :is-full-page="fullPage"
      :height="height"
      :width="width"
      background-color="#6b6969"
    />
    <nav
      class="navbar navbar-color-on-scroll fixed-top navbar-expand-lg"
      color-on-scroll="100"
      id="sectionsNav"
    >
      <div class="container-fluid">
        <div class="navbar-translate">
          <router-link to="/">
            <h5 class="text-dark" style="font-size: 48px; font-weight: 900">
              Quiz
            </h5>
          </router-link>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="navbar-toggler-icon" />
            <span class="navbar-toggler-icon" />
            <span class="navbar-toggler-icon" />
          </button>
        </div>

        <div class="collapse navbar-collapse">
          <div class="navbar-nav pt-2 ml-auto">
            <div class="card" style="border-radius: 10px">
              <div class="pl-1 pr-1 pt-1 pb-1">
                <div class="row">
                  <div class="col-2">
                    <span class="material-icons mt-2"> schedule </span>
                  </div>
                  <div class="col-10">
                    <div class="pl-1">Time Remaining</div>
                    <div class="pl-1">24:40</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ul class="navbar-nav pt-2">
            <li class="p-2">
              <button
                class="btn btn-orange btn-round pt-3 pb-3"
                style=""
                @click="submitFinalForm"
              >
                Submit answers
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <form @submit.prevent="submitForm">
      <section class="container-fluid job-fair-text" style="padding-top: 12rem">
        <div class="row">
          <div class="col-md-12 mb-3" v-for="(q, i) in quizes" :key="i">
            <ul>
              <li>
                {{ q.question }}
              </li>
            </ul>

            <div class="form-group clearfix">
              <div class="radio-item" v-for="(o, a) in q.option" :key="a">
                <input
                  type="radio"
                  :name="'item' + i"
                  :id="i + 'option' + a"
                  :value="o"
                  v-model="q['answer']"
                  required
                />
                <label :for="i + 'option' + a">{{ o }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12">
            <hr />
          </div>
          <div class="col-md-6 text-left">
            <div>Page {{ page }} OF {{ chunks.length }}</div>
          </div>
          <div class="col-md-6 text-right">
            <button
              type="button"
              class="btn btn-default btn-circle mr-2"
              :disabled="page <= 1"
              @click="backButtonGetQuestion"
            >
              <i class="material-icons"> arrow_back </i>
            </button>
            <button
              class="hidden"
              style="display: none;"
              ref="final_submission"
            >
              final submission
            </button>
            <button
              type="submit"
              :disabled="page === chunks.length"
              class="btn btn-green btn-circle"
            >
              <span class="material-icons"> arrow_forward </span>
            </button>
          </div>
        </div>
      </section>
    </form>
    <!-- Modal -->
    <div
      class="modal fade"
      id="quizPromptModal"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      aria-labelledby="successModalLable"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div> -->
          <div class="modal-body">
            <div class="row" style="margin-top: 2rem; margin-bottom: 2rem">
              <div class="col-md-4 d-none d-sm-none d-md-block" style="margin-top: auto; margin-bottom: auto;">
                <div>
                  <img src="@/assets/quiz_timer.png" class="img-fluid" alt="" />
                </div>
              </div>
              <div class="col-md-7 offset-md-1">
                <h3 class="text-green">This is a timed quiz</h3>
                <p class="text-danger">
                  Make sure to have a good internet connection
                </p>
                <p class="text-danger">
                  Please do not close this exam session page during test.
                </p>
                <p style="color: #727272;">
                  Are you sure you are ready to start the quiz? You will be
                  given <span class="text-dark">60 minutes</span> to complete
                  it.
                </p>
                <p style="color: #727272;">
                  Once you reach the time limit, the quiz would be over
                </p>
                <p style="color: #727272;">Goodluck.</p>
                <router-link
                  to="/dashboard"
                  class="btn btn-outline-dark btn-curve mt-3 mr-3"
                  style="background: white; padding: 12px 20px; font-size: 12px"
                  data-dismiss="modal"
                  >Back to dashboard
                </router-link>
                <a
                  data-dismiss="modal"
                  class="btn btn-orange text-light btn-round mt-3"
                  style="padding: 12px 20px; font-size: 12px"
                  >Start Quiz
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="successModal"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      aria-labelledby="successModalLable"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" id="modal-back">
          <!-- <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div> -->
          <div class="modal-body">
            <div class="row" style="margin-top: 10rem; margin-bottom: 10rem">
              <div class="col-md-3 offset-md-1">
                <img
                  src="@/assets/quiz_complete_icon.png"
                  class="img-fluid"
                  alt=""
                />
              </div>
              <div class="col-md-7 offset-md-1">
                <h3 class="text-green">Congratulations</h3>
                <p class="text-dark">{{success_text}}</p>
                <router-link
                  to="/"
                  class="btn btn-outline-dark btn-curve mt-3"
                  style="background: white; padding: 12px 20px; font-size: 12px"
                  data-dismiss="modal"
                  >Back to dashboard
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="resitModal"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      aria-labelledby="resitModalLable"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div> -->
          <div class="modal-body">
            <div class="row" style="margin-top: 10rem; margin-bottom: 10rem">
              <div class="col-md-3 offset-md-1">
                <img
                  src="@/assets/quiz_resit.png"
                  class="img-fluid"
                  alt=""
                />
              </div>
              <div class="col-md-7 offset-md-1">
                <h3 class="text-danger">You didn’t pass this one</h3>
                <p class="text-dark">Write the copy about cost and next step</p>
                <router-link
                    to="/dashboard"
                    class="btn btn-outline-dark btn-curve mt-3 mr-3"
                    style="background: white; padding: 12px 20px; font-size: 12px"
                    data-dismiss="modal"
                >Back to dashboard
                </router-link>
                <a
                    data-dismiss="modal"
                    class="btn btn-orange text-light btn-round mt-3"
                    style="padding: 12px 20px; font-size: 12px"
                >Resit exams
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

// import Footer from "../components/Footer";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import moment from "moment";
import $ from "jquery";

export default {
  name: "Jobs",
  data() {
    return {
      isLoading: false,
      fullPage: true,
      success_text: "",
      height: 128,
      width: 128,
      quizes: [],
      all_data: [],
      chunks: [],
      page: 0,
      final_submission: false,
      payload: {
        user_id: this.$store.state.userInfo.id,
        answers: [],
        module_id: this.$route.params.id
      }
    };
  },
  components: {
    TopNavbar: () => import("@/components/TalentNav"),
    Loading,
    bottomFooter: () => import("@/components/Footer")
  },
  methods: {
    submitFinalForm() {
      this.$refs.final_submission.click();
    },
    submitForm() {
      if (this.page != this.chunks.length) {
        let submit_answers = true;
        this.chunks.forEach(e => {
          e.forEach(item => {
            if (!item["answer"]) {
              submit_answers = false;
              return;
            }
          });
        });

        if (submit_answers) {
          this.submitAnswer();
        }

        this.page++;
        this.quizes = this.chunks[this.page - 1];
        this.final_submission = this.page === this.chunks.length;
      } else {
        this.submitAnswer();
      }
    },

    submitAnswer() {
      this.isLoading = true;
      this.payload.answers = [];
      this.chunks.forEach(e => {
        e.forEach(item => {
          this.payload.answers.push(item);
        });
      });
      axios
        .post(`${process.env.VUE_APP_COMPANY_URL}/submit-answers`, this.payload)
        .then(res => {
          this.success_text = res.data.message;
          window.$("#successModal").modal("show");
          console.log(res);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    forwardBtn() {
      this.page++;
      this.quizes = this.chunks[this.page - 1];
    },
    backButtonGetQuestion() {
      this.page--;
      this.quizes = this.chunks[this.page - 1];
    },
    getQuiz() {
      this.isLoading = true;
      axios
        .get(
          `${process.env.VUE_APP_COMPANY_URL}/quiz/module/${this.$route.params.id}`
        )
        .then(res => {
          this.all_data = res.data.data.data;
          this.chunks = res.data.data.chunks;
          if (this.chunks.length > 0) {
            this.page = 1;
            this.quizes = this.chunks[0];
            window.$("#quizPromptModal").modal("show");
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  created() {
    this.getQuiz();
  }
};
</script>

<style src="../../../public/assets/css/general-front-css.css" scoped />

<style scoped>
.navbar {
  background: #fefbfb !important;
  box-shadow: 0px 1px 16px rgba(48, 36, 42, 0.1) !important;
}

/* navbar styling */
label {
  color: #131212;
}

.nav-item a {
  color: white;
  font-family: var(--gotham);
  font-size: 1.1em;
}

#modal-back {
  background-image: url("../../assets/quiz_complete_back.png");
  background-size: cover;
}

/* header */
header {
  height: 60vh;
  /*background: url('../../assets/events/events-bg.png');*/
  width: 100%;
}

.text h1 {
  font-size: 3.125em;
  font-family: var(--gothamBold);
  margin-bottom: 1.5rem;
}

.text p {
  margin-bottom: 1.5rem;
}

/* job fair section*/

.heading h2 {
  font-size: 1.875em;
  font-family: var(--gothamBold);
  margin-bottom: 0;
  color: white;
  text-align: center;
}

.job-fair-text {
  width: 90%;
  /*margin-top: -3rem;*/
  border-radius: 10px;
  padding: 1rem 3rem;
  text-align: left !important;
}

/* upcoming events */

.card {
  color: black;
  margin: 1rem 0;
  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.1);
}

@media screen and (max-width: 599px) and (min-width: 300px) {
  .job-fair-text {
    padding: 0;
  }
}

.radio-item {
  /*display: inline-block;*/
  position: relative;
  padding: 0 6px;
  margin: 10px 0 0;
}

.radio-item input[type="radio"] {
  /*display: none;*/
  opacity: 0;
  position: relative;
  left: 25px;
}

.radio-item label {
  color: #666;
  font-weight: normal;
  padding-left: 10px;
}

.radio-item label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 5px;
  margin: 0 5px 0 0;
  width: 20px;
  height: 20px;
  border-radius: 11px;
  border: 2px solid #727272;
  background-color: transparent;
}

.radio-item input[type="radio"]:checked + label:after {
  border-radius: 11px;
  width: 12px;
  height: 12px;
  position: absolute;
  top: 9px;
  left: 33px;
  content: " ";
  display: block;
  background: #059ca6;
}

.radio-item input[type="radio"]:checked + label:before {
  border: 2px solid #059ca6;
}

.radio-item input[type="radio"]:checked + label {
  width: 110px;
  background: #f2feff;
  padding-bottom: 5px;
  border-radius: 5px;
}

ul {
  list-style: "#";
}

ul li {
  padding-left: 8px;
}
</style>
